<template>
  <transition name="modal">
    <div v-if="dialogData" class="layer-modal">
      <div class="toast">
        <div class="modal-container">
          <p v-if="isHtmlMessage" v-html="$t(dialogData.message)"></p>
          <p v-else>{{ $t(dialogData.message) }}</p>

          <p v-if="dialogData.rejectReasons">
            <select v-model="reason">
              <option value="">{{ $t('manageMember.select') }}</option>
              <option v-for="(item, index) in dialogData.rejectReasons" :key="index"
                :value="$t(item)">{{ $t(item) }}</option>
              <option value="custom">{{ $t('common.enterDirect') }}</option>
            </select>
            <template v-if="reason === 'custom'">
              <p>
                <input type="text" maxlength="200" class="customReasonInput"
                  v-model.trim="customReason">
              </p>
              <p>{{ $t('manageMember.rejectReasonMinChar') }}</p>
            </template>
          </p>

          <p class="btns">
            <button type="button" class="btn_2"
              @click="onDialogResove(true)"
              :disabled="isButtonDisabled">
              {{ $t(dialogData.ok) }}
            </button>
            <button type="button" class="btn_3"
              v-if="dialogData.cancel" @click="onDialogResove(false)">
              {{ $t(dialogData.cancel) }}
            </button>
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import modalEvent from '@/lib/modal-event'

export default {
  name: 'ModalDialog',
  data () {
    return {
      reason: '',
      customReason: null
    }
  },
  computed: {
    ...mapState(['dialogData']),
    isHtmlMessage () {
      if (this.dialogData.message) {
        return this.$t(this.dialogData.message).indexOf('<br>') !== -1
      }
      return false
    },
    isButtonDisabled () {
      if (this.dialogData.rejectReasons) {
        if (this.reason === 'custom') {
          if (!this.customReason ||
            this.customReason.trim().length <= 4) {
            return true
          }
        } else if (!this.reason) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    onDialogResove (value) {
      if (value && this.dialogData.rejectReasons) {
        if (this.reason === 'custom') {
          value = this.customReason
        } else {
          value = this.reason
        }
      }
      modalEvent.resolveDialog(value)
    }
  }
}
</script>

<style scoped>
.customReasonInput {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/global/ModalDialog.vue